import React from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

import IntegrationDetailModal from './IntegrationListingGrid/IntegrationDetailModal';

interface Props {
  integrationId: number;
  isOpen: boolean;
  onClose: () => void;
}

/**
 * Shared dialog shell for BPA integration details. The content component owns
 * data loading and error reporting; this wrapper keeps the modal presentation
 * identical wherever integration details are opened.
 */
const IntegrationDetailsDialog = ({
  integrationId,
  isOpen,
  onClose,
}: Props) => (
  <Modal isOpen={isOpen} toggle={onClose} size="lg">
    <ModalHeader toggle={onClose}>
      <h4>Integration Details</h4>
    </ModalHeader>
    <ModalBody>
      {isOpen && (
        <IntegrationDetailModal id={integrationId} onClose={onClose} />
      )}
    </ModalBody>
    <ModalFooter>
      <Button color="secondary" onClick={onClose}>
        Cancel
      </Button>
    </ModalFooter>
  </Modal>
);

export default IntegrationDetailsDialog;
